import { NgModule } from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';

// @dynamic
@NgModule({
  imports: [NzModalModule],
})
export class DtConfirmModule {}
